import { html } from 'lit';
import componentStyles from './here-to-help.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class HereToHelp extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      info: { type: Object },
      helpBlocks: { type: Object },
    };
  }

  constructor() {
    super();
    this.info = {};
    this.helpBlocks = [];
  }

  render() {
    return html`
      <div class="here-to-help">
        <div class="here-to-help__left_column">
          <div class="here-to-help__left_column-row">
            <hf-heading class="here_to_help__heading" levelstyle="heading2"
              >${this.info.help}</hf-heading
            >
            <hf-paragraph>${this.info.time}</hf-paragraph>
          </div>
          <div class="here-to-help__left_column-row">
            <hf-paragraph class="here_to_help__heading" bold
              >${this.info.enroll}</hf-paragraph
            >
            <hf-paragraph>${this.info.dates}</hf-paragraph>
          </div>
        </div>
        <div class="here-to-help__right_column">
          ${this.helpBlocks.map(helpBlock => {
            return html` <div class="here-to-help__right_column-row">
              <hf-paragraph class="here_to_help__heading" bold
                >${helpBlock.heading}</hf-paragraph
              >
              <hf-paragraph>
                <hf-link href="${helpBlock.phone_url}" white
                  >${helpBlock.phone}</hf-link
                >
              </hf-paragraph>
              <hf-paragraph class="here_to_help__heading">
                ${Drupal.t('TDD/TTY')}
                <hf-link href="${helpBlock.tdd_url}" white>
                  ${helpBlock.tdd}
                </hf-link>
              </hf-paragraph>
            </div>`;
          })}
        </div>
      </div>
    `;
  }
}

customElements.define('hf-here-to-help', HereToHelp);
